import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(err => {
    // Log bootstrap errors instead of silently swallowing them
    // eslint-disable-next-line no-console
    console.error('Angular bootstrap error', err);
    // Best-effort attempt to hide native Cordova splash screen
    // even if Angular failed to bootstrap.
    try {
        const nav = navigator;
        if (window.cordova && nav && nav.splashscreen && typeof nav.splashscreen.hide === 'function') {
            nav.splashscreen.hide();
        }
    }
    catch (hideError) {
        // eslint-disable-next-line no-console
        console.error('Failed to hide splashscreen after bootstrap error', hideError);
    }
});
